/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A powerful collection of specialized tools built with cutting-edge web technologies, blazing fast, and designed for precision.`)
};

const es_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una poderosa colección de herramientas especializadas, ultrarrápidas y diseñadas para la precisión.`)
};

const de_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine leistungsstarke Sammlung spezialisierter Werkzeuge — blitzschnell und auf Präzision ausgelegt.`)
};

const nl_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een krachtige verzameling gespecialiseerde tools — razendsnel en ontworpen voor precisie.`)
};

const fr_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une collection puissante d’outils spécialisés construits avec des technologies web de pointe, ultra-rapides et conçus pour la précision.`)
};

const it_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una potente raccolta di strumenti specializzati costruiti con tecnologie web all’avanguardia, velocissimi e progettati per la precisione.`)
};

const pt_br2_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coleção poderosa de ferramentas especializadas construídas com tecnologias web de ponta, ultravelózes e projetadas para a precisão.`)
};

const pt_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coleção poderosa de ferramentas especializadas construídas com tecnologias web de ponta, ultra-rápidas e concebidas para precisão.`)
};

const ja_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最先端のウェブ技術で構築された強力な専門ツールのコレクション — 超高速で精度重視。`)
};

const zh_footer_tagline = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强大的专业工具集合 — 极速运行，专为精准而设计。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_tagline = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_tagline(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("footer_tagline", locale)
	if (locale === "en") return en_footer_tagline(inputs)
	if (locale === "es") return es_footer_tagline(inputs)
	if (locale === "de") return de_footer_tagline(inputs)
	if (locale === "nl") return nl_footer_tagline(inputs)
	if (locale === "fr") return fr_footer_tagline(inputs)
	if (locale === "it") return it_footer_tagline(inputs)
	if (locale === "pt-BR") return pt_br2_footer_tagline(inputs)
	if (locale === "pt") return pt_footer_tagline(inputs)
	if (locale === "ja") return ja_footer_tagline(inputs)
	return zh_footer_tagline(inputs)
};